import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorMessage from "../../components/ErrorMessage";
import PrimaryButton from "../../components/PrimaryButton";
import Spacer from "../../components/Spacer";
import { IApplicationState } from "../../store";
import { authenticationRequest } from "../../store/authentication/slice";
import LogoDark from "../../assets/images/infinitysafe_horizontal_full_dark.png";
import { Container, Input, Logo } from "./styles";
import { useTranslation } from "react-i18next";

const Authentication: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const authentication = useSelector((state: IApplicationState) => state.authentication);

    const handleAuthentication = () => {
        if(!authentication.isLoading){
            dispatch(authenticationRequest({
                username,
                password
            }))
        }
    }
    return <Container>
        <Logo src={LogoDark} alt="Infinity Safe" />
        <form onSubmit={(event) => {
            event.preventDefault();
            event.stopPropagation();

            handleAuthentication();
        }}>
            <Input 
                onChange={(event) => {
                    setUsername(event.target.value)
                }}
                autoComplete="username"
                value={username}
                placeholder={t('pages.authentication.inputs.username')}
            />
            <Input 
                onChange={(event) => {
                    setPassword(event.target.value)
                }}
                autoComplete="current-password"
                value={password}
                type={'password'}
                placeholder={t('pages.authentication.inputs.password')}
                 />
            <PrimaryButton onClick={() => handleAuthentication()}>{authentication.isLoading ? t('pages.authentication.buttons.logining') : t('pages.authentication.buttons.login')}</PrimaryButton>
            
            <Spacer size={8} />
            {authentication.error !== undefined && <ErrorMessage>{authentication.error.message || t("common.errors.unexpected")}</ErrorMessage>}
        </form>
    </Container>
}

export default Authentication;